import React from "react";
import { Mode } from "../../../../utils";
import { mergeDeep } from "../../../../utils/Helper";
import { CustodyLock, CustodyIntStatus } from "../../../Custody/types";

export const initialize = (props) => {
  return (initialState) => {
    let state = mergeDeep(
      { ...initialState },
      {
        ui: {
          mode: props.mode || Mode.EDIT,
          loading: props.retriveAsync,
        },
        custody: {
          ...props.custody,
          actualstatus: props.custody.internalstatus,
        },
      }
    );
    if (state.ui.mode == Mode.READONLY) {
      Object.keys(state.custody).forEach((f) => {
        state.fields.readonly[f] = true;
      });

      state.buttons.precheck.readonly = true;
    }

    return state;
  };
};

export const defaultState = () => ({
  ui: {
    title: "Custody",
    mode: Mode.EDIT,
  },
  fields: {
    errors: {},
    readonly: {},
    hiddens: {},
  },
  custody: {
    id: null,
    assetid: null,
    assetticker: null,
    accountId: null,
    accountName: null,
    accountNumber: null,
    internalstatus: CustodyIntStatus.ClientRequest,
    date: new Date().toDateLocal(),
    volume: null,
    reference: null,
    docreference: null,
    externaldate: "0000-00-00",
    type: CustodyLock.LockSelf,
    denominationUsed: [],
  },
  buttons: {
    confirm: {
      visible: false,
    },
    precheck: {
      visible: true,
    },
    modify: {
      visible: false,
    },
  },
});
